import { ITable } from '../ApiManager';

type Response = { response: any; key: string };

async function EncontrarEmOutraTabela(
  table: ITable,
  { id }: any,
): Promise<Response | undefined> {
  const resultAndKey = await Promise.all(
    Object.keys(table).map(async key => {
      const response = await table[key as keyof ITable].get(id);
      return { response, key };
    }),
  ).then(array => array.find(result => result.response !== undefined));

  return resultAndKey;
}

export { EncontrarEmOutraTabela };
